import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";

const ConfirmModal = ({
  modal,
  setModal,
  title,
  body,
  action,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "primary",
  // while true both buttons are disabled and the modal cannot be dismissed
  busy = false,
  // false leaves the modal open so the caller can close it once the action
  // has finished (pair it with `busy`)
  closeOnConfirm = true,
}) => {
  const close = () => {
    if (!busy) setModal(false);
  };

  return (
    <>
      <Modal isOpen={modal} toggle={close}>
        <ModalHeader toggle={close}>{title}</ModalHeader>
        {body && <ModalBody>{body}</ModalBody>}

        <ModalFooter>
          <Button color="light" onClick={close} disabled={busy}>
            {cancelLabel}
          </Button>
          <Button
            color={confirmColor}
            className="ml-2"
            disabled={busy}
            onClick={() => {
              action();
              if (closeOnConfirm) setModal(false);
            }}
          >
            {busy && <Spinner size="sm" className="mr-1" />}
            {confirmLabel}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ConfirmModal;
